var exports = {
  "wg": "OperatorPassPurchasesSection.module__pageLink___MkIzRm",
  "CY": "OperatorPassPurchasesSection.module__loadFailed___MkIzRm",
  "DO": "OperatorPassPurchasesSection.module__loadFailedText___MkIzRm",
};

module.exports = exports;
